/** DisciplineIndex.jsx - the contents list: one row per discipline with its progress. */
import { GREEN, GREY, HAIRLINE, INK, LABEL, RULE, SUBLABEL } from './theme';
import { clampPct, signedCount } from './helpers';
import { Bar, StatusKey } from './Primitives';

export function IndexRow({ discipline, last }) {
  const pct = clampPct(discipline);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flexWrap: 'wrap',
        padding: '9px 0',
        borderBottom: last ? 'none' : '1px solid ' + HAIRLINE,
      }}
    >
      <span
        style={{
          flex: '2 1 110px',
          minWidth: 0,
          fontSize: 12.5,
          fontWeight: 700,
          color: INK,
          letterSpacing: '0.1px',
          overflowWrap: 'anywhere',
          lineHeight: 1.4,
        }}
      >
        {discipline.label}
      </span>
      <span style={{ flex: '1 1 70px', minWidth: 56 }}>
        <Bar pct={pct} height={6} />
      </span>
      <span
        style={{
          display: 'flex',
          alignItems: 'baseline',
          gap: 8,
          flexShrink: 0,
          whiteSpace: 'nowrap',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        <span style={{ width: 52, textAlign: 'right', fontSize: 11.5, color: GREY }}>
          {signedCount(discipline)}/{discipline.total || 0}
        </span>
        <span
          style={{
            width: 40,
            textAlign: 'right',
            fontSize: 12.5,
            fontWeight: 800,
            color: pct >= 100 ? GREEN : INK,
          }}
        >
          {pct}%
        </span>
      </span>
    </div>
  );
}

export function DisciplineIndex({ disciplines }) {
  return (
    <section style={{ marginTop: 20 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 12,
          paddingBottom: 6,
          borderBottom: '1px solid ' + RULE,
        }}
      >
        <span style={LABEL}>Discipline index</span>
        <span style={{ ...SUBLABEL, whiteSpace: 'nowrap' }}>Signed / total</span>
      </div>
      {disciplines.map((discipline, i) => (
        <IndexRow key={discipline.id || i} discipline={discipline} last={i === disciplines.length - 1} />
      ))}
      <div style={{ height: 1, background: HAIRLINE }} />
      <StatusKey />
    </section>
  );
}

/* --------------------------------- phase rows -------------------------------- */
